// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-cookie{font-size:10px!important}.mobile-cookie-button{font-size:8px!important;margin-top:15px;height:35px!important}.mobile-cookie-container{padding:0 0!important}div{color:var(--v-text-base)}.v-alert__content{color:#fff}.v-messages__message{font-size:16px!important;line-height:18px!important;color:var(--v-error-base)}.v-alert--prominent .v-alert__icon:after{opacity:0}", ""]);
// Exports
module.exports = exports;
